import React from "react";
import "./gallery.scss";

/* REDUX */
import { useSelector, useDispatch } from "react-redux";
import { hideGallery } from "../../redux/actions";

const Gallery = () => {
  const gallery = useSelector((state) => state.gallery);
  const dispatch = useDispatch();

  if (gallery.active)
    return (
      <section className='gallery' onClick={() => dispatch(hideGallery())}>
        <div className='gallery__box'>
          <img
            src={
              gallery.file
                ? `${
                    process.env.NODE_ENV === "production"
                      ? window.location.origin
                      : "http://localhost:8000"
                  }/${gallery.file}`
                : ""
            }
            alt=''
          />
        </div>
      </section>
    );

  return null;
};

export default Gallery;
